import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import firebase from "../Firebase/Firebase";
import Formatter from "../Formatters/Formatters";
import QRCode from "qrcode.react";
import "./Request.css";

class Request extends Component {
  constructor() {
    super();

    this.state = {
      id: "",
      name: "",
      phoneNumber: "",
      amount: 0,
      description: "",
      createdAt: "",
      copySucceeded: false,
      copyFailed: false
    };

    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.openWhatsApp = this.openWhatsApp.bind(this);
    this.openEmail = this.openEmail.bind(this);
  }

  componentDidMount() {
    const id = this.props.match.params.id;

    this.setState({ id });

    return firebase
      .database()
      .ref("/requests/" + id)
      .once("value")
      .then(snapshot => {
        const request = snapshot.val();

        this.setState({ ...request });
      });
  }

  getPaymentRequestUrl() {
    const id = this.state.id;
    return `${window.location.origin}/s/${id}`;
  }

  getPaymentRequestSubjectText() {
    const { amount, description } = this.state;

    return encodeURIComponent(
      `Puedes transferirme COP ${amount} para ${description}?`
    );
  }

  getPaymentRequestText() {
    const { amount, description } = this.state;

    return encodeURIComponent(
      `Puedes transferirme COP ${amount} para ${description}? Puedes seguir este enlace para completar la transferencia: ${this.getPaymentRequestUrl()}`
    );
  }

  copyToClipboard() {
    const paymentRequestLink = ReactDOM.findDOMNode(
      this.refs.paymentRequestLink
    );
    const range = document.createRange();

    range.selectNode(paymentRequestLink);
    window.getSelection().addRange(range);

    try {
      // Now that we've selected the anchor text, execute the copy command
      const successful = document.execCommand("copy");

      if (successful) {
        this.setState({ copySucceeded: true });
      } else {
        this.setState({ copyFailed: true });
      }
    } catch (err) {
      this.setState({ copyFailed: true });
    }

    // Remove the selections
    window.getSelection().removeAllRanges();
  }

  openWhatsApp() {
    window.location = `whatsapp://send?text=${this.getPaymentRequestText()}`;
  }

  openEmail() {
    window.location = `mailto:?to=&body=${this.getPaymentRequestText()},&subject=${this.getPaymentRequestSubjectText()}`;
  }

  render() {
    const {
      id,
      name,
      phoneNumber,
      amount,
      description,
      copySucceeded,
      copyFailed
    } = this.state;

    return (
      <div className="request">
        <h1 className="request-title">Solicitud de dinero</h1>
        <dl className="request-details-list">
          <dt className="request-details-item-term">Monto</dt>
          <dd className="request-details-item-data">
            COP {Formatter.numberToPrice(amount, { showDecimals: false })}
          </dd>
          <dt className="request-details-item-term">Transferir a</dt>
          <dd className="request-details-item-data">
            <div>{name}</div>
            <div>+{phoneNumber}</div>
            <div>Bancolombia</div>
            <div>6091287301223</div>
            <Link to={`/perfil?paymentRequestId=${id}`}>Editar</Link>
          </dd>
          <dt className="request-details-item-term">Descripción</dt>
          <dd className="request-details-item-data">{description}</dd>
        </dl>
        <div className="request-panel-url">
          <div className="request-qr">
            <QRCode value={this.getPaymentRequestUrl()} />
          </div>
          <Link to={`/s/${id}`} ref="paymentRequestLink">
            {this.getPaymentRequestUrl()}
          </Link>
          {copySucceeded && (
            <div className="request-copy-success">
              Enlace copiado al portapapeles
            </div>
          )}
          {copyFailed && (
            <div className="request-copy-failed">
              No se puede copiar al portapapeles
            </div>
          )}
        </div>
        <div className="request-panel-buttons">
          <button
            className="request-button button-green"
            onClick={this.copyToClipboard}
          >
            Copiar al portapapeles
          </button>
          <button
            className="request-button button-green"
            onClick={this.openWhatsApp}
          >
            Compartir por WhatsApp
          </button>
          <button
            className="request-button button-green"
            onClick={this.openEmail}
          >
            Compartir por Email
          </button>
          <Link to="/">volver a la página de resumen</Link>
        </div>
      </div>
    );
  }
}

export default Request;



// WEBPACK FOOTER //
// ./src/Request/Request.js